var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyWorkspaceActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_922_1841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 32C8 32 6 32 6 30C6 28 8 22 16 22C24 22 26 28 26 30C26 32 24 32 24 32H8ZM16 20.1C17.3261 20.1 18.5979 19.5732 19.5355 18.6355C20.4732 17.6978 21 16.4261 21 15.1C21 13.7739 20.4732 12.5021 19.5355 11.5644C18.5979 10.6268 17.3261 10.1 16 10.1C14.6739 10.1 13.4021 10.6268 12.4645 11.5644C11.5268 12.5021 11 13.7739 11 15.1C11 16.4261 11.5268 17.6978 12.4645 18.6355C13.4021 19.5732 14.6739 20.1 16 20.1Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 2C2.93913 2 1.92172 2.42143 1.17157 3.17157C0.421427 3.92172 0 4.93913 0 6L0 25C0 25.7956 0.31607 26.5587 0.87868 27.1213C1.44129 27.6839 2.20435 28 3 28H4.306C4.72418 26.5302 5.45102 25.1666 6.438 24H2V6C2 5.46957 2.21071 4.96086 2.58579 4.58579C2.96086 4.21071 3.46957 4 4 4H28C28.5304 4 29.0391 4.21071 29.4142 4.58579C29.7893 4.96086 30 5.46957 30 6V24H25.562C26.67 25.308 27.342 26.746 27.694 28H29C29.7956 28 30.5587 27.6839 31.1213 27.1213C31.6839 26.5587 32 25.7956 32 25V6C32 4.93913 31.5786 3.92172 30.8284 3.17157C30.0783 2.42143 29.0609 2 28 2H4Z",
    fill: "#232323"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_922_1841"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyWorkspaceActive);
export default __webpack_public_path__ + "static/media/MyWorkspaceActive.b8b5ad5cfacd3525936976fef55c76b4.svg";
export { ForwardRef as ReactComponent };